function getBootstrapPayload() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.__SUARTE_SSR__?.discover ?? null;
}

export function getSsrDiscoverBootstrap(routeKind) {
  const payload = getBootstrapPayload();
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  if (payload.routeKind !== routeKind) {
    return null;
  }

  return payload;
}
